import { render } from "./TNIcon.vue?vue&type=template&id=62c4d504"
import script from "./TNIcon.vue?vue&type=script&lang=js"
export * from "./TNIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__